import Wallet from "../../pages/tronvault/Wallet";
import WithdrawUSDT from "../../pages/tronvault/WithdrawUSDT";
import WithdrawBatchUSDT from "../../pages/tronvault/WithdrawBatchUSDT";
import WithdrawTRX from "../../pages/tronvault/WithdrawTRX";
import VerifyDeposit from "../../pages/tronvault/VerifyDeposit";
import VerifyAddress from "../../pages/tronvault/VerifyAddress";
import ContractUSDTBalance from "../../pages/tronvault/ContractUSDTBalance";
import ContractTRXBalance from "../../pages/tronvault/ContractTRXBalance";
import WalletUSDTBalance from "../../pages/tronvault/WalletUSDTBalance";
import WalletTRXBalance from "../../pages/tronvault/WalletTRXBalance";
import WalletDetails from "../../pages/tronvault/WalletDetails";
import Register from "../../pages/tronvault/Register";

const myroutes = [
  { path: "/", element: <h1>صفحه اصلی / ورود</h1> },
  { path: "/wallet", element: <Wallet /> },
  // { path: "/register", element: <Register /> },
  { path: "/withdraw/usdt", element: <WithdrawUSDT /> },
  { path: "/withdraw/batch/usdt", element: <WithdrawBatchUSDT /> },
  { path: "/withdraw/trx", element: <WithdrawTRX /> },
  { path: "/verify/deposit", element: <VerifyDeposit /> },
  { path: "/verify/address/:address", element: <VerifyAddress /> },
  { path: "/contract/usdt/balance", element: <ContractUSDTBalance /> },
  { path: "/contract/trx/balance", element: <ContractTRXBalance /> },
  { path: "/wallet/:id/usdt/balance", element: <WalletUSDTBalance /> },
  { path: "/wallet/:id/trx/balance", element: <WalletTRXBalance /> },
  { path: "/wallet/:id", element: <WalletDetails /> },
  { path: "*", element: <h1>Page Not Found</h1> },
];

export default myroutes;
